import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import services from 'src/services/risk-assessment.service';
import { IRiskAssessmentSchema } from 'src/models/risk-assessment.model';

export const actionTypes = {
  RISK_ASSESSMENT_FETCH: 'RISK_ASSESSMENT_FETCH',
  RISK_ASSESSMENT_ADD: 'RISK_ASSESSMENT_ADD',
  RISK_ASSESSMENT_UPDATE: 'RISK_ASSESSMENT_UPDATE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request

export const asyncActions = {
  dataGET: {
    type: actionTypes.RISK_ASSESSMENT_FETCH,
    service: services.dataGET,
  },
  addPost: {
    type: actionTypes.RISK_ASSESSMENT_ADD,
    service: services.addPost,
    meta: { error: false },
  },
  updatePut: {
    type: actionTypes.RISK_ASSESSMENT_UPDATE,
    service: services.updatePut,
    meta: { error: false },
  },
};

export type IRiskAssessmentAsync = typeof asyncActions;

export interface IRiskAssessmentState
  extends ICommonState<IRiskAssessmentAsync> {
  data?: IRiskAssessmentSchema;
  list: IRiskAssessmentSchema[];
}
export const defaultState: IRiskAssessmentState = {
  status: {},
  list: [],
};

const RiskAssessmentReducer = (
  state: IRiskAssessmentState = defaultState,
  action: IReducerAction<IRiskAssessmentAsync>
): IRiskAssessmentState => {
  switch (action.type) {
    case actionTypes.RISK_ASSESSMENT_FETCH: {
      return {
        ...state,
        data: action.payload?.riskAssessment,
      };
    }

    default: {
      return state;
    }
  }
};

export default RiskAssessmentReducer;
